import $ from "jquery";
import { MORPH_DATA, state } from "../../core/settings";
import { summaryButtonComponent } from "../summary/summary-button/summaryButton";
import interfaceHTML from "./interface.html";
import "./interface.scss";
import { interfaceGroupComponent } from "./interfaceItems/interfaceGroup/interfacGroup";
import {
  interfaceGroupInputsComponent,
  typesInputs,
  updateTextParam,
} from "./interfaceItems/interfaceGroup/interfaceGroupInputs/interfaceGroupInputs";

export const step = !state.model ? 17 : 20;

const textWall = updateTextParam(state, this, false, true);
const textElectro = updateTextParam(state, this, true, true);
const textSub = updateTextParam(state, this, true, true, true);

export const groups = [
  {
    title: "Model",
    param: !state.model ? "TitanCover™" : "LiteShade™",
    type: typesInputs.radioModel,
  },
  { title: "Wall", param: textWall, type: typesInputs.selectButton },
  {
    title: "Roof",
    param: !state.model ? "Louvered" : state.typeLiteShadeRoof,
    type: !state.model ? typesInputs.range : typesInputs.roofForLite,
    ranges: [
      {
        title: "Rotation",
        min: 0,
        max: 90,
        step: 1,
        thumb: false,
        initialValue: state.currentRotationZ,
        showLabels: true,
        showSwitchAngle: true,
      },
    ],
  },
  {
    title: "Roof Type",
    param: state.patternScreenRoof,
    type: typesInputs.roofTypes,
  },
  {
    title: "Dimensions",
    param: `${state.width}' x ${state.length}' x ${state.height}'`,
    type: typesInputs.range,
    ranges: [
      {
        title: "Width",
        min: 6,
        max: 40,
        step: 1,
        thumb: true,
        initialValue: state.width,
        showLabels: true,
        showSwitchAngle: false,
        inch: true,
      },
      {
        title: "Projection",
        min: 6,
        max: 40,
        step: 1,
        thumb: true,
        initialValue: state.length,
        showLabels: true,
        showSwitchAngle: false,
        inch: true,
      },
      {
        title: "Height",
        min: 8,
        max: 12,
        step: 1,
        thumb: true,
        initialValue: state.height,
        showLabels: true,
        showSwitchAngle: false,
        inch: true,
      },
    ],
  },
  {
    title: "Post Size",
    param: `${state.initValuePostSize}`,
    type: typesInputs.postSize,
    initValuePostSize: state.initValuePostSize,
  },
  {
    title: "Frame Color",
    param: state.colorBody,
    type: typesInputs.colorsButton,
  },
  {
    title: "Roof Color",
    param: state.colorRoof,
    type: typesInputs.colorsButton,
  },
  {
    title: "Electrical Options",
    param: textElectro,
    type: typesInputs.electronic,
  },
  { title: "Accessories", param: textSub, type: typesInputs.subSystem },
];

export function interfaceComponent(container) {
  const componentContent = $(
    '<div class="interface-container" id="interface"></div>'
  );

  const interfaceElement = $(interfaceHTML);

  groups.forEach((group) => {
    const groupComponent = interfaceGroupComponent(group.title, group.param);
    const groupComponentInputs = $(
      '<div class="interface__group__inputs"></div>'
    );
    groupComponentInputs.append(
      interfaceGroupInputsComponent(
        group.type,
        group?.ranges,
        group?.initValuePostSize,
        group.title
      )
    );
    groupComponent.append(groupComponentInputs);

    groupComponentInputs.hide();

    interfaceElement.append(groupComponent);
  });

  $(componentContent).append(interfaceElement);

  summaryButtonComponent(componentContent);
  $(container).append(componentContent);
}
